export default class CInputManager {

    constructor(canvas) {
        canvas.addEventListener('mousemove', this._callbackMouseMove());
        canvas.addEventListener('mousedown', this._callbackMouseDown());
        canvas.addEventListener('mouseout', this._callbackMouseOut());
        this._clickCallbacks = [];
        this._mouseOverCallbacks = [];
        this._mouseOverActive = null;
    }

    clear() {
        this._mouseOverCallbacks = [];
        this._clickCallbacks = [];
    }


    _callbackMouseOut() {
        let me = this;
        return ()=> {
            if (me._mouseOverActive) {
                me._mouseOverActive['callbackOut']();
                me._mouseOverActive = null;
            }
        };

    }

    _callbackMouseMove() {
        let me = this;
        return function (e) {
            let x = e.offsetX;
            let y = e.offsetY;
            let find = null;
            me._mouseOverCallbacks.forEach(function (config) {
                if (x >= config['x1'] && x <= config['x2'] && y >= config['y1'] && y <= config['y2']) {
                    find = config;
                }
            });

            if (me._mouseOverActive && find !== me._mouseOverActive) {
                me._mouseOverActive['callbackOut']();
                me._mouseOverActive = null;
            }

            if (find && find !== me._mouseOverActive) {
                find['callbackOn']();
                me._mouseOverActive = find;
            }
        };

    }

    _callbackMouseDown() {
        let me = this;
        return function (e) {
            let x = e.offsetX;
            let y = e.offsetY;
            me._clickCallbacks.forEach( (config)=> {
                if (x >= config['x1'] && x <= config['x2'] && y >= config['y1'] && y <= config['y2']) {
                    config['callback']();
                }
            });
        };
    }

    addEventClick(x1, y1, x2, y2, callback) {
        this._clickCallbacks.push({
            'x1': x1,
            'y1': y1,
            'x2': x2,
            'y2': y2,
            'callback': callback
        });
    }

    addEventMouseOver(x1, y1, x2, y2, callbackOn, callbackOut) {
        this._mouseOverCallbacks.push({
            'x1': x1,
            'y1': y1,
            'x2': x2,
            'y2': y2,
            'callbackOn': callbackOn,
            'callbackOut': callbackOut,
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/cchart/CInputManager.js